import { ISelectType } from "@4uhub/lib4uhub";
import z from "zod";

export const filterModalSchema = z.object({
  encounterNumber: z.string().nullish(),
  establishmentCodeOs: z.string().nullish(),
  encounterNumberOS: z.string().nullish(),
  individualIdentifierOs: z.string().nullish(),
  individualIdentifier: z.string().nullish(),
  individualDocumentOs: z.string().nullish(),
  individualNameOs: z.string().nullish(),
  encounterDateEntryStart: z.date().nullish(),
  encounterDateEntryEnd: z.date().nullish(),
  encounterDateEntryOption: z.custom<ISelectType>().nullish()
});

export type TFilterModalSchema = z.infer<typeof filterModalSchema>;
